import React, { Component } from "react";
import PropTypes from "prop-types";
import { message } from "antd";
import createHmac from "create-hmac";
import Elevio from "elevio/lib/react";
import { elevioTranslations, userVoiceTranslations } from "../../constants/supportTranslations";
import { ELEVIO_ACCOUNT, ELEVIO_SECRET } from "../../config";

class UserVoice extends Component {
  static propTypes = {
    user: PropTypes.object,
    userVoiceScript: PropTypes.object
  };

  componentDidUpdate(prevProps) {
    const { user, userVoiceScript } = this.props;
    if (user && user !== prevProps.user) {
      this.initializeUserVoice(userVoiceScript);
    }
  }

  initializeUserVoice(userVoiceScript) {
    let showWidget;

    if (UserVoice) {
      showWidget = true;
    }
    try {
      userVoiceScript.push([
        "set",
        {
          trigger_position: "bottom-right",
          contact_enabled: false,
          mode: "satisfaction",
          locale: "it",
          menu: true,
          smartvote_enabled: false,
          post_suggestion_enabled: false,
          ticket_custom_fields: {
            Fatture: "Invio fatture"
          },
          trigger_color: "#FFF",
          trigger_background_color: "#FFFFFF",
          strings: userVoiceTranslations
        }
      ]);

      if (this.props.user) {
        userVoiceScript.push([
          "identify",
          {
            email: this.props.user.profile.id, // User’s email address
            name: this.props.user.profile.lastName + " " + this.props.user.profile.firstName // User’s real name
          }
        ]);
      }

      userVoiceScript.push(["addTrigger"]);
      if (showWidget && this.props.user && this.props.user.profile.id) {
        userVoiceScript.push(["show"]);
      }
    } catch (e) {
    }
  }

  openScoreModule(id) {
    if (id.toString() === "11") {
      try {
        document.getElementsByClassName("uv-icon")[0].click();
      } catch (e) {
        message.warning("Accedi per votare! ");
      }
    }
  }

  setUser() {
    const { user } = this.props;
    if (!user || !user.profile) return undefined;
    let elevioAccountSecret = ELEVIO_SECRET; /** è l'account secret da recuperare su account elevio */
    const hmac = createHmac("sha256", Buffer.from(elevioAccountSecret));
    hmac.update(user.profile.id);
    let hash = hmac.digest("hex");

    return {
      first_name: user.profile.firstName,
      last_name: user.profile.lastName,
      email: user.profile.id,
      user_hash: hash
    };
  }

  render() {
    return (
      <div>
        <Elevio accountId={ELEVIO_ACCOUNT} onModuleOpened={this.openScoreModule.bind(this)} translations={elevioTranslations} user={this.setUser()} />
      </div>
    );
  }
}
export default UserVoice;
